import React from 'react';
import { Link } from 'react-router-dom';
import { LayoutDashboard, MessageSquare, Crown, Wallet, Users } from 'lucide-react';

// Same destinations/labels the Command Center already links to.
export const buildMemberLinks = (teamId) => [
  { href: '/member', label: 'Command Center', icon: LayoutDashboard, key: 'command-center' },
  ...(teamId
    ? [
        { href: `/member/community/${teamId}`, label: 'Team Community', icon: MessageSquare, key: 'team-community' },
        { href: `/member/franchise/${teamId}`, label: 'Franchise Roadmap', icon: Crown, key: 'franchise-roadmap' },
        { href: `/member/money-pot/${teamId}`, label: 'Money Pot', icon: Wallet, key: 'money-pot' },
      ]
    : [{ href: '/select-team', label: 'Join a Team', icon: Users, key: 'join-team' }]),
];

export const MemberMobileNav = ({ teamId, pathname, onNavigate }) => (
  <nav aria-labelledby="mobile-member-nav-heading" className="px-4 pb-4 mb-3 border-b border-border" data-testid="mobile-member-nav">
    <p
      id="mobile-member-nav-heading"
      className="font-mono text-[11px] uppercase tracking-[0.25em] text-primary mb-2 px-1"
    >
      Member Pages
    </p>
    <ul className="space-y-1">
      {buildMemberLinks(teamId).map((l) => {
        const active = pathname === l.href;
        const Icon = l.icon;
        return (
          <li key={l.key}>
            <Link
              to={l.href}
              onClick={onNavigate}
              aria-current={active ? 'page' : undefined}
              data-testid={`mobile-member-nav-${l.key}`}
              className={`flex w-full min-h-[44px] items-center gap-3 px-3 py-3 border-l-2 font-heading uppercase tracking-wider text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary ${
                active ? 'border-primary bg-primary/10 text-primary' : 'border-transparent text-foreground hover:bg-zinc-900/80'
              }`}
            >
              <Icon className="w-5 h-5 flex-shrink-0" aria-hidden="true" />
              <span className="min-w-0 flex-1 [overflow-wrap:anywhere]">{l.label}</span>
              {active && <span className="font-mono text-[10px] tracking-widest text-primary/80">Current</span>}
            </Link>
          </li>
        );
      })}
    </ul>
  </nav>
);
